import { render, staticRenderFns } from "./BroadcastView.vue?vue&type=template&id=3251e58c&"
import script from "./BroadcastView.vue?vue&type=script&lang=ts&"
export * from "./BroadcastView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports